import { useEffect } from "react";
import CTA from "../components/CTA";
import "../css/dialog.scss";

const DialogComponent = (props) => {
  useEffect(() => {
    //check if cookie exist bfcm-closed-dialog dont show dialog else show dialog
    const cookie = document.cookie;
    if (!cookie.includes("bfcm-show-dialog")) {
      return;
    } else {
      const dialog = document.getElementById("dialog-popup-bfcm");
      dialog.classList.add("active");
      document.body.classList.add("dialog-active");
      dialog.dispatchEvent(new Event("open"));

      const closeDialog = dialog.querySelector(".dialog-close");
      closeDialog.addEventListener("click", () => {
        document.body.classList.remove("dialog-active");
        dialog.classList.remove("active");
        document.cookie = "bfcm-show-dialog=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      });

      dialog.addEventListener("click", (e) => {
        if (e.target !== e.currentTarget) {
          return;
        }
        document.body.classList.remove("dialog-active");
        dialog.classList.remove("active");
        document.cookie = "bfcm-show-dialog=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      });
    }
  }, []);

  return (
    <div id="dialog-popup-bfcm" className="dialog">
      <div className="dialog-wrapper">
        <button className="dialog-close">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8 8">
            <path
              fill="currentColor"
              d="M7 6.998c.348-.348.312-.804-.036-1.152L4.732 3.614 6.964 1.37C7.3 1.034 7.348.578 7 .23c-.324-.324-.804-.3-1.14.036L3.628 2.498 1.384.266C1.048-.07.568-.094.244.23c-.348.348-.3.804.036 1.14l2.232 2.244L.28 5.846c-.348.348-.384.804-.036 1.152.324.324.804.3 1.14-.036l2.244-2.244L5.86 6.962c.324.336.816.36 1.14.036z"
            ></path>
          </svg>
        </button>
        <div className="dialog-inner">
          <div className="dialog-content">
            <div className="dialog-content-inner-left">
              <h6 className="title">
                BFCM <br />
                Masterclass
              </h6>
              <p className="main-text">
                Live insights from
                <br /> eCommerce experts
              </p>
              <span className="bordered">September 29th, 2:00 PM EST</span>
              <CTA href="#" title="SAVE YOUR SPOT" icon="arrow-right" segmentLocation="BFCM dialog popup" />
            </div>
            <div className="dialog-content-inner-right">
              <img src={process.env.PUBLIC_URL + "/assets/dialogPopup.png"} alt="Dialog" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DialogComponent;
